import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import MLIcon from '../../MLIcon';
import s from './styles.module.css';


function MLTab(props) {
  MLTab.propTypes = {
    label: PropTypes.string.isRequired,
    tabClassName: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    activeTab: PropTypes.bool.isRequired,
    iconType: PropTypes.string,
    iconCSSClass: PropTypes.string,
  };

  const {
    label,
    activeTab,
    tabClassName,
    onClick,
    iconType,
    iconCSSClass,
  } = props;

  const tabClass = activeTab ? `${s.mlTab} ${s.mlTabActive}` : s.mlTab;

  const handleSelectWithKey = (event) => {
    if (event.key === 'Enter') {
      props.onClick(label);
    }
  };

  let iconClass = s.icon;
  if (iconType && iconCSSClass) iconClass = `${s.icon} ${iconCSSClass}`;

  return (
    <div
      tabIndex="0"
      role="button"
      aria-label={label}
      className={clsx(tabClass, tabClassName)}
      data-test-id={`${label}-tab-toggle`}
      onKeyDown={handleSelectWithKey}
      onClick={() => { onClick(label); }}
    >
      {iconType && <MLIcon type={iconType} className={iconClass} />}
      {label}
    </div>
  );
}

export default MLTab;
